import { Box, IconButton } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { CardCloseButtonProps } from "shared/components/card/CardCloseButton";
import { XIcon } from "shared/icons/XIcon";

export interface TableBoxPanelProps {
  onClose: () => void;
}

export const TableBoxPanel: React.FC<
  React.PropsWithChildren<TableBoxPanelProps>
> = ({ onClose, children }) => (
  <Box borderLeftWidth="1px" minW="480px" maxW="480px" h="100%">
    <TableBoxPanelCloseButton onClick={onClose} />
    <Box overflowY="auto" h="100%">
      {children}
    </Box>
  </Box>
);

const TableBoxPanelCloseButton: React.FC<CardCloseButtonProps> = ({
  onClick,
}) => {
  const { t } = useTranslation(["common"]);
  return (
    <Box position="relative" w="100%" top="0" right="0">
      <IconButton
        variant="ghost"
        colorScheme="gray"
        aria-label={t("common:close")}
        size="xs"
        icon={<XIcon />}
        onClick={onClick}
        minWidth="24px"
        minHeight="24px"
        alignSelf="flex-start"
        position="absolute"
        top="8px"
        right="8px"
      />
    </Box>
  );
};
